import checkReadOnlyAPI from '../api/ui/checkReadOnlyAPI';

export const getUserPageAuth = async (user) => {
  try {
    const currentURL = window.location.pathname;
    const depth = currentURL.split('/');
    const url = depth.splice(0, 5).join('/');

    const result = await checkReadOnlyAPI.checkComponent(url, user);
    if (result) {
      console.log(`페이지: ${url} 읽기전용: ${result}`);
      return result;
    }
    // readOnly가 설정된 정보를 찾을 수 없으므로 false를 반환
    console.log(`페이지: ${url} 읽기전용: ${result}`);
    return false;
  } catch (error) {
    console.error(
      '에러로 인해 페이지 권한을 읽기 전용으로 리턴함\nError:',
      error,
    );
    return true;
  }
};
